/**
 * Blocage d’affichage Assist : client déclaré mobile ou petit côté d’écran
 * physique sous le plancher (voir MIN_SUPPORTED_PHYSICAL_SHORT_SIDE).
 */

/** Court bord minimum du panneau (px physiques approx.). 600 = plancher type 1024×600. */
export const MIN_SUPPORTED_PHYSICAL_SHORT_SIDE = 600;

const PHONE_UA_RE =
  /Android.+Mobile|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i;

const DISPLAY_GEOMETRY_EVENTS = ["resize", "orientationchange"] as const;

type NavigatorMobileHints = {
  userAgent?: string;
  userAgentData?: { mobile?: boolean };
};

const hasWindow = (): boolean => typeof window !== "undefined";

/** Court bord du panneau en pixels physiques approximatifs. */
export function getPhysicalScreenShortSide(
  screenWidth: number = typeof screen !== "undefined" ? screen.width : Infinity,
  screenHeight: number = typeof screen !== "undefined"
    ? screen.height
    : Infinity,
  devicePixelRatio: number = hasWindow() ? window.devicePixelRatio || 1 : 1
): number {
  return Math.min(screenWidth, screenHeight) * devicePixelRatio;
}

/**
 * Client déclaré mobile (Client Hint, sinon UA téléphone).
 * N’inclut pas iPad / tablettes Android « desktop-like ».
 */
export function isDeclaredMobileClient(
  nav: NavigatorMobileHints | null | undefined = typeof navigator !==
  "undefined"
    ? navigator
    : undefined
): boolean {
  if (!nav) return false;
  if (typeof nav.userAgentData?.mobile === "boolean") {
    return nav.userAgentData.mobile;
  }
  return PHONE_UA_RE.test(nav.userAgent ?? "");
}

/**
 * True si l’affichage est bloqué : client déclaré mobile, ou petit côté
 * d’écran physique sous le plancher.
 */
export function isAssistDisplayBlocked(
  shortSide?: number,
  declaredMobile?: boolean
): boolean {
  const side =
    shortSide ?? (hasWindow() ? getPhysicalScreenShortSide() : Infinity);
  const mobile =
    declaredMobile ?? (hasWindow() ? isDeclaredMobileClient() : false);
  return mobile || side < MIN_SUPPORTED_PHYSICAL_SHORT_SIDE;
}

/** Re-évalue le prédicat quand la géométrie d’écran / DPR peut changer. */
export function subscribeAssistDisplayGeometry(
  onChange: () => void
): () => void {
  for (const event of DISPLAY_GEOMETRY_EVENTS) {
    window.addEventListener(event, onChange);
  }
  return () => {
    for (const event of DISPLAY_GEOMETRY_EVENTS) {
      window.removeEventListener(event, onChange);
    }
  };
}
